export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';
export const UPDATE_ORIGINAL_APPLICATION = 'UPDATE_ORIGINAL_APPLICATION';
export const UPDATE_APPLICATION_ATTRIBUTE = 'UPDATE_APPLICATION_ATTRIBUTE';
export const UPDATE_APPLICATION_WORKFLOW_STATE = 'UPDATE_APPLICATION_WORKFLOW_STATE';
export const UPDATE_APPLICATION_CHECK_STATUS_ID = 'UPDATE_APPLICATION_CHECK_STATUS_ID';
export const UPDATE_APPLICATION_CHECK_STATUS_CHARACTER = 'UPDATE_APPLICATION_CHECK_STATUS_CHARACTER';
export const UPDATE_APPLICATION_CHECK_STATUS_RETURN = 'UPDATE_APPLICATION_CHECK_STATUS_RETURN';
export const UPDATE_APPLICATION_FEE_STATUS = 'UPDATE_APPLICATION_FEE_STATUS';
export const UPDATE_APPLICATION_ASSESS_STATUS = 'UPDATE_APPLICATION_ASSESS_STATUS';
export const UPDATE_ORG_APPLICANT = 'UPDATE_ORG_APPLICANT';
export const UPDATE_PROXY_APPLICANT = 'UPDATE_PROXY_APPLICANT';
export const UPDATE_SELECTED_TAB_ID = 'UPDATE_SELECTED_TAB_ID';
export const UPDATE_SELECTED_TAB_NAME = 'UPDATE_SELECTED_TAB_NAME';
export const UPDATE_SELECTED_TAB_WORKFLOW_STATE = 'UPDATE_SELECTED_TAB_WORKFLOW_STATE';
export const UPDATE_SELECTED_APPLY_ORG_ID = 'UPDATE_SELECTED_APPLY_ORG_ID';
export const UPDATE_SELECTED_APPLY_PROXY_ID = 'UPDATE_SELECTED_APPLY_PROXY_ID';
export const UPDATE_SELECTED_APPLY_LICENCE_SELECT = 'UPDATE_SELECTED_APPLY_LICENCE_SELECT';
export const UPDATE_RECEPTION_METHOD_ID = 'UPDATE_RECEPTION_METHOD_ID';
export const UPDATE_RENDERER_TABS = 'UPDATE_RENDERER_TABS';
export const UPDATE_RENDERER_SECTIONS = 'UPDATE_RENDERER_SECTIONS';
export const UPDATE_RETURNS = 'UPDATE_RETURNS';
export const UPDATE_RETURNS_ESTIMATE = 'UPDATE_RETURNS_ESTIMATE';
export const UPDATE_RETURNS_EXTERNAL = 'UPDATE_RETURNS_EXTERNAL';
export const UPDATE_RETURNS_SELECTED_SPECIES = 'UPDATE_RETURNS_SELECTED_SPECIES';
export const UPDATE_RETURNS_SPECIES = 'UPDATE_RETURNS_SPECIES';
export const UPDATE_RETURNS_TABS = 'UPDATE_RETURNS_TABS';
export const UPDATE_RETURNS_TRANSFER_SPECIES = 'UPDATE_RETURNS_TRANSFER_SPECIES';
export const UPDATE_VISIBLE_COMPONENT = 'UPDATE_VISIBLE_COMPONENT';
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
export const UPDATE_CURRENT_USER_ID = 'UPDATE_CURRENT_USER_ID';
export const TOGGLE_FINALISED_TABS = 'TOGGLE_FINALISED_TABS';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
export const REMOVE_FORM_FIELD = 'REMOVE_FORM_FIELD';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js